import React from 'react';
import './SubscriptionPlanBenefitsList.less';
import { PlanSectionListItem } from './components';
import clsx from 'clsx';
import { TextContentType } from 'utils/text/renderTextContent';

export interface SubscriptionPlanBenefitsListItem {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  text: TextContentType;
}

interface Props {
  className?: string;
  items: SubscriptionPlanBenefitsListItem[];
}

export default function SubscriptionPlanBenefitsList({
  className,
  items,
}: Props) {
  return (
    <ul className={clsx('subscription-plan-benefits-list', className)}>
      {items.map((item, index) => {
        const { icon, text } = item;
        return <PlanSectionListItem key={index} itemIcon={icon} text={text} />;
      })}
    </ul>
  );
}
